import { ajax } from 'application/src/js/functions.js';

/**
 * @param {Node} args.container outer HTML element
 * @param {object} args.translations text translations object
 * @param {Pagination} args.pagination Pagination instance
 */
export default class OfferViewsList {
  constructor(args) {
    this.container = args.container;
    if(!this.container) return;

    this.list = this.container.querySelector('.component-items');
    if(!this.list) return;

    this.translations = args.translations;
    this.pagination = args.pagination;
    this.loader = this.container.querySelector('.uic-spinner-overlay');
    this.numResultsOut = this.container.querySelector('.num-results');
    this.pageIndex = 0;
    this.perPage = 10;
    this.requestVisitorsUrl = this.list.getAttribute('data-request-visitors-url');
    this.requestMailingUrl = this.list.getAttribute('data-request-mailing-url');
    this.views = [];

    this.loadViews()
      .then(response => {
        this.views =
          this.sortByDate(
            this.flatten(
              this.aggregate([
                ...response[0].data.map(v => {
                  v.pageNav = v.amount;
                  return v;
                }),
                ...response[1].data.clickList.map(v => {
                  v.clickedMail = v.amount;
                  return v;
                }),
                ...response[1].data.openList.map(v => {
                  v.openedMail = v.amount;
                  return v;
                })
              ])
            )
          );

        this.numResultsOut.innerHTML = this.views.length;
        this.numResultsOut.style.display = 'inline-block';
        this.pagination.update(this.views.length, this.perPage);
        this.addEvents();
        this.render();

        this.loader.style.display = 'none';
      })
      .catch(e => {
        console.log(e);
        this.container.style.display = 'none';
      });
  }

  aggregate(views) {
    return views.reduce((prev, curr) => {
      if(prev[curr.formattedDate]) {
        if(prev[curr.formattedDate][curr.globalAddressContactId]) {
          if(prev[curr.formattedDate][curr.globalAddressContactId].timestamp < curr.timestamp) {
            prev[curr.formattedDate][curr.globalAddressContactId] = Object.assign(prev[curr.formattedDate][curr.globalAddressContactId], curr);
          } else {
            prev[curr.formattedDate][curr.globalAddressContactId] = Object.assign(curr, prev[curr.formattedDate][curr.globalAddressContactId]);
          }
        } else {
          prev[curr.formattedDate][curr.globalAddressContactId] = curr;
        }
      } else {
        prev[curr.formattedDate] = {}
        prev[curr.formattedDate][curr.globalAddressContactId] = curr;
      }

      return prev;
    }, []);
  }

  sortByDate(views) {
    views.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    return views;
  }

  flatten(views) {
    return Object.keys(views).reduce((prev, curr) => {
      prev = [...prev, ...Object.values(views[curr])];
      return prev;
    }, []);
  }

  addEvents() {
    this.pagination.subscribe('pageChange', pageIndex => {
      this.pageIndex = pageIndex;
      this.render();
    });
  }

  loadViews() {
    this.loader.style.display = 'block';

    return Promise.all([
      ajax(this.requestVisitorsUrl, {
        per_page: this.perPage,
        page_index: this.pageIndex,
      }),
      ajax(this.requestMailingUrl, {
        per_page: this.perPage,
        page_index: this.pageIndex,
      })
    ]);
  }

  render() {
    this.list.innerHTML = '';
    this.pageIndex = this.pagination.update(this.views.length, this.perPage);

    this.pagination.getVisibleItems(this.views, this.perPage, this.pageIndex).map(view => {
      const viewElement = document.createElement('div');
      this.list.insertAdjacentElement('beforeend', viewElement);

      new OfferView({
        element: viewElement,
        translations: this.translations,
        data: view
      });
    });
  }
}

class OfferView {
  constructor(args) {
    this.element = args.element;
    this.translations = args.translations;
    this.data = args.data;
    this.element.className = 'component-item';
    this.render();
  }

  render() {
    this.element.innerHTML = this.template;
  }

  get userName() {
    return `${this.data.lastname}${this.data.firstname ? `, ${this.data.firstname}` : ``}`;
  }

  get template() {
    return `
      <div class="component-item">
        <div class="date-time">${this.data.formattedDate} ${this.data.formattedTime}</div>
        <div class="user-name">
          ${this.data.globalAddressContactId ? `
            <a href="/mundus-agri/addressDetails/${this.data.globalAddressId}?tabid=3&cid=${this.data.globalAddressContactId}">${this.userName}</a>
          ` : this.userName}
        </div>
        <div class="company">
          ${this.translations.from}
          ${this.data.globalAddressId ? `
            <a href="/mundus-agri/addressDetails/${this.data.globalAddressId}" class="company-name">${this.data.companyName}</a>
            ` : `<span class="company-name">${this.data.companyName}</span>
          `}
        </div>
      </div>
    `;
  }
}